<template>
  <modal :state="state" :index="index" @toggle-modal="hideModal">
    <div slot="body">
      <br />
      <h3 class="modal-title">{{ header }}</h3>
      <p v-if="!isAccountRelationship">
        Deleting {{ relationTitle }} will also remove this relationship in the related model.
        Properties linked to this relationship will be invalid in ALL items using the property.
      </p>
      <p v-else>
        Deleting {{ relationTitle }} will remove all users' access to this model, its records,
        any related model records, and any contextual permissions given to {{ relationTitle }}.
      </p>
      <p>Are you sure that you want to proceed?</p>
      <div class="cta">
        <button
          type="button"
          @click="hideModal(vueModalID.confirmDeleteObjectModelRelationship)"
          class="btn block grey outline">
          Cancel
        </button>
        <button
          type="button"
          @click="remove"
          class="btn block red"
          data-action="affirm">
          Delete
        </button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
  import Vue from "vue";
  import modalComponentMixin from "~/mixins/modalComponentMixin";
  import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";
  import {ObjectModelRelationType} from "~/enums/objectModelRelationType";

  export default Vue.extend({
    props: {
      relationship: Object as () => ObjectModelRelation,
    },
    mixins: [modalComponentMixin],
    components: {
    },
    data: function() {
      return {
      };
    },
    computed: {
      isAccountRelationship(): boolean {
        return this.relationship.isAccountRelationship;
      },
      header(): string {
        if (this.relationship.relation_type === ObjectModelRelationType.Account) {
          return "Delete account relationship";
        } else if (this.relationship.relation_type === ObjectModelRelationType.EntityAccount) {
          return "Delete entity account relationship";
        } else {
          return "Delete relationship";
        }
      },
      relationTitle(): string {
        return this.relationship.labelTitleOr('Untitled');
      }
    },
    methods: {
      remove(): void {
        this.$emit("remove", this.relationship);
      },
      hideModal(event) {
        this.emitHideModal(event);
      },
    },
  });
</script>